import { GROUP_TYPE } from '../domain/domainCodes'
import StatusBadge from './StatusBadge'

/**
 * A group's kind, wherever it is shown (2026-10-22, the client's request): a department in
 * blue, a custom group in violet — two fixed hues, so the pair reads apart at a glance on
 * every page and under any identity.
 *
 * @param {number|string} typeId  `dbo.GroupTypes` — 1 department, 2 custom group
 * @param {import('react').ReactNode} children  the type's name, as the server sends it
 */
export default function GroupTypeBadge({ typeId, children }) {
  const department = Number(typeId) === GROUP_TYPE.DEPARTMENTS
  return (
    <StatusBadge tone={department ? 'info' : 'violet'} plain>
      {children}
    </StatusBadge>
  )
}
